import onEscapePress from '@vue-storefront/core/mixins/onEscapePress'
import { Wishlist } from 'src/modules/vsf-magento-wishlist/components/Wishlist'
export default {
  name: 'Wishlist',
  props: {
    // deprecated
    product: {
      type: Object,
      required: false,
      default: () => { }
    }
  },
  methods: {
    // theme-specific
    onEscapePress () {
      this.$store.dispatch('ui/closeWishlist')
    }
  },
  mixins: [ Wishlist, onEscapePress ]
}
